import { Builder, BuilderComponent, builder } from '@builder.io/react';
import '@builder.io/widgets';

import { CTAButton } from '@components/common/presentational/buttons/cta';
import UpcomingTab from '@pages/shop/partial/upcoming';
import Growing from '@v2/components/pages/home/home-growing';
import AgeBundles from '@v2/components/pages/home/home-age-bundles';
import Shop from '@components/builderio/shop/shop-body';

/**
 * In order to integrate our components into builder.io custom page
 * you need to load the url of the existing page in builder.io dashboard
 * navigating to "Preview url" input at the top-right corner
 *
 * Custom components documentation: https://www.builder.io/c/docs/custom-react-components
 */

/* Main components */
Builder.registerComponent(
    (props: any) => (
        <CTAButton
            text={props.text}
            url={props.url}
            width={props.width}
            style={props.style}
            ctaEventName={props.ctaEventName}
            ctaEventPage={props.ctaEventPage}
        />
    ),
    {
        name: 'CTA Button',
        inputs: [
            {
                name: 'text',
                type: 'string',
            },
            {
                name: 'url',
                type: 'url',
            },
            {
                name: 'style',
                type: 'string',
                defaultValue: 'BLUE',
                enum: ['BLUE', 'RED', 'SECONDARY', 'LINK'],
            },
            {
                name: 'width',
                type: 'number',
            },
            {
                name: 'ctaEventName',
                type: 'string',
            },
            {
                name: 'ctaEventPage',
                type: 'string',
            },
        ]
    }
);

/* Page components */
Builder.registerComponent(
    (props: any) => (
        <UpcomingTab />
    ),
    {
        name: 'Upcoming Banner',
        inputs: []
    }
);
Builder.registerComponent(
    (props: any) => <AgeBundles/>,
    {name: 'Age Bundles',}
);
Builder.registerComponent(
    (props: any) => (
        <Growing
            isBuilder={true}
            title={props.title}
            description={props.description}/>
    ),
    {
        name: 'Your Baby’s Brain',
        inputs: [
            {
                name: 'title',
                type: 'string',
            },
            {
                name: 'description',
                type: 'string',
            },
        ]
    }
);
Builder.registerComponent(
    (props: any) => (
        <Shop/>
    ),
    {
        name: 'Shop Product Listing',
        inputs: []
    }
);

export { BuilderComponent, builder }